export default {
  map: { position: "relative", marginBottom: "20px" },
  propertyList: {
    position: "relative"
  }
};
